import styles from './DataRangePicker2.module.css'
import { Calendar } from 'components/Calendar'
import { useState } from 'react'
import { DataRangePicker2CustomDay } from './DataRangePicker2CustomDay'
import { PickersDay, PickersDayProps } from '@mui/x-date-pickers'
import { DateTime, Interval } from 'luxon'
import classNames from 'classnames'

export type DatePosition = 'start' | 'end' 

interface DateInterval{
    startDate?: DateTime
    endDate?: DateTime
}

interface DataRangePicker2Props{
    value: DateInterval[]
    isLoading?: boolean
    onValueChange?: (value: any) => void
}


export const DataRangePicker2 = (props: DataRangePicker2Props) => {
    const {
        value = [],
        isLoading = false,
        onValueChange,
    } = props

    const [datePosition, setDatePosition] = useState<DatePosition>('start') 

    const handleStartDate = (value: DateInterval[] | undefined, date: DateTime | undefined): boolean => {
        if (date === undefined){
            return false
        }       

        if (value === undefined){
            return false
        }

        const firstElement = value[0]
        if (firstElement === undefined){
             return false
        }

        if (firstElement.startDate === undefined){
            return false
        }

        return firstElement.startDate.hasSame(date, 'day')
    }

    const handleEndDate = (value: DateInterval[]  | undefined, date: DateTime | undefined): boolean => {
        if (date === undefined){
            return false
        }  

        if (value === undefined){
            return false
        }

        const firstElement = value[0]
        if (firstElement === undefined){
             return false
        }


        if (firstElement.endDate === undefined){
            return false
        }

        return firstElement.endDate.hasSame(date, 'day')
    }

    const handleInInterval = (value: any | undefined, date: DateTime | undefined): boolean => {
        if (date === undefined){
            return false
        }  

        if (value === undefined){
            return false
        }

        const firstElement = value[0]
        if (firstElement === undefined){
             return false
        }

        if (firstElement.startDate === undefined){
            return false
        }

        if (firstElement.endDate === undefined){
            return false
        }

        const interval = Interval.fromDateTimes(
            firstElement.startDate,
            firstElement.endDate
        )

        return interval.contains(date)
    }

    const customDay = (props: PickersDayProps<DateTime>) => {
        const { day, onClick, ...other } = props
        const isStart = handleStartDate(value, day)
        const isEnd = handleEndDate(value, day)
        const isInInterval = handleInInterval(value, day)

        const dayClasses = classNames(styles.DataRangePicker2__CustomDay, {
            [styles[`DataRangePicker2__CustomDay--Start`]]: isStart,
            [styles[`DataRangePicker2__CustomDay--End`]]: isEnd, 
            [styles[`DataRangePicker2__CustomDay--InInterval`]]: isInInterval            
        })       

        const handlePickersDayClick = (event:any ) => {
            if (datePosition === 'start'){
                onValueChange?.([{startDate: day, endDate: undefined}])
                setDatePosition('end')
            }

            if (datePosition === 'end'){
                onValueChange?.([{startDate: value[0]?.startDate, endDate: day}])
                setDatePosition('start')
            }

            if (onClick) {
                onClick(event)
            }
        }

        return (
            <PickersDay 
                {...props}
                selected={false}
                today={false}
                className={dayClasses}
                onClick={handlePickersDayClick}
            />
        )
    }

    return (
        <Calendar
            loading={isLoading}
                slots={{
                    calendarHeader: () => (null),
                    day: customDay,
                }}
        />
    )
}